<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" :title="$t('amazon.amazon42')" width="90%">
      <section>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('fba.sendAddress')" prop="ids">
                <el-select v-model="form.ids" clearable filterable :placeholder="$t('common.pleaseSelect')" size="small">
                  <el-option v-for="item in sendAddressList" :key="item.id" :label="item.detailedAddresserInfo" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('fba.line')" prop="route">
                <el-select v-model="form.route" :placeholder="$t('common.pleaseSelect')" size="small" clearable @change="lineChange" value-key="value">
                  <el-option v-for="item in routeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('fba.logisticsCompany')" label-width="100px" prop="logisticsCompanyId">
                <el-select v-model="form.logisticsCompanyId" :placeholder="$t('common.pleaseSelect')" size="small" clearable @change="logisticsChange" value-key="id">
                  <el-option v-for="item in dropDownListEdit" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('common.remark')" label-width="50px">
                <el-input
                    v-model="form.comments"
                    clearable
                    :placeholder="$t('common.pleaseInput')"
                    size="small"
                    type="input"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <el-table
            ref="goodsTableRef"
            :data="goodsList"
            :height="360"
            row-key="id"
            @select="handleSelect"
            @select-all="handleSelectAll"
        >
          <el-table-column align="center" type="selection" width="55"> </el-table-column>
          <el-table-column type="index" :label="$t('wzbg.wz6')" align="center" width="40"></el-table-column>
          <el-table-column align="center" prop="clientManagerUserName" :label="$t('cnumber.cnumber30')" width="70"> </el-table-column>
          <el-table-column align="center" prop="id" :label="$t('fba.orderNo')" width="70"> </el-table-column>
          <el-table-column prop="goodsName" :label="$t('fba.goodsName')" min-width="200"></el-table-column>
          <el-table-column :label="$t('OrderDetail.OrderDetail54')" min-width="250" align="center" width="180">
            <template slot-scope="scope">
              <img :src="scope.row.pictureUrl" width="180" height="320" class="head_pic" />
            </template>
          </el-table-column>
          <el-table-column prop="orderType" align="center" label="FBA YFF/ZOZO/RSL" width="90">
            <template v-slot="scope">
              <span v-if="scope.row.orderType == 0">FBA</span>
              <span v-if="scope.row.orderType == 1">{{$t('filter.filter36')}}</span>
              <span v-if="scope.row.orderType == 2">YFF</span>
              <span v-if="scope.row.orderType == 3">ZOZO</span>
              <span v-if="scope.row.orderType == 4">RSL</span>
            </template>
          </el-table-column>
          <el-table-column prop="fnsku" label="FNSKU" align="center"></el-table-column>
          <el-table-column prop="goodsNameCus" :label="$t('OrderDetail.OrderDetail55')" align="center" width="180">
            <template v-slot="scope">
              <el-input type="textarea" placeholder="" v-model="scope.row.goodsNameCus" size="small" disabled>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="orderStatus" align="center" :label="$t('fba.orderState')" width="90">
            <template v-slot="scope">
              <div v-for="(item, i) in orderStatusOptions" :key="i">
                <div v-if="scope.row.orderStatus == item.value">
                  {{ item.label }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="categoryFlag" align="center" :label="$t('fba.storage')" width="110">
            <template v-slot="scope">
              <span v-if="scope.row.warehouseStorageDays != null && scope.row.checkFinishTime != null">
                <span v-if="scope.row.warehouseStorageDays >= 10">
                  {{ $t("orderList.orderList140") }} {{ scope.row.warehouseStorageDays }}日
                </span>
                <span v-if="scope.row.warehouseStorageDays < 10 && scope.row.warehouseStorageDays > 0" style="color: orange">
                  {{ $t("orderList.orderList140") }} {{ scope.row.warehouseStorageDays }}日
                </span>
                <span v-if="scope.row.warehouseStorageDays == 0" style="color: red">
                  {{ $t("orderList.orderList140") }} {{ scope.row.warehouseStorageDays }}日
                </span>
                <span v-if="scope.row.warehouseStorageDays < 0" style="color: red">
                  {{ $t("orderList.orderList142") }} {{ Math.abs(scope.row.warehouseStorageDays) }}日
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="goodsCount" :label="$t('orderList.orderList29')" align="center"></el-table-column>
          <el-table-column prop="destroyCount" :label="$t('fba.destroyNumber')" align="center" width="90"></el-table-column>
          <el-table-column prop="refundCount" :label="$t('fba.returnNumber')" align="center" width="90"></el-table-column>
          <el-table-column prop="canApplyCount" :label="$t('fba.canApplyCount')" align="center" width="90"></el-table-column>
          <el-table-column prop="netWeight" :label="$t('orderList.orderList130')" align="center">
            <template v-slot="scope">
              {{scope.row.netWeight * scope.row.canApplyCount}}
            </template>
          </el-table-column>
          <el-table-column align="center" label="申请数量">
            <template #default="{ row }">
              <el-input v-model="row.containerGoodsCount" isInteger type="number"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </section>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" class="search-btn btn-gray" @click="cancelForm('form')">取 消</el-button>
        <el-button size="small" class="search-btn btn-blue" type="primary" @click="handleSubmit('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import t from "@/i18n/ja-JP"
export default {
  name: 'packingOrder',
  data() {
    return {
      dialogVisible: false,
      form: {
        ids: '',
        comments: '',
        logisticeCompany: '',
        logisticsCompanyId: '',
        route: '',
        listOrderJson: '',
      },
      rules: {
        ids: [
          { required: true, message: this.$t('FBAContainerOrder.FBAContainerOrder3'), trigger: 'change' }
        ],
        route: [
          { required: true, message: this.$t('FBAContainerOrder.FBAContainerOrder5'), trigger: 'change' }
        ],
        logisticsCompanyId: [
          { required: true, message: this.$t('FBAContainerOrder.FBAContainerOrder6'), trigger: 'change' }
        ],
      },
      sendAddressList: [],
      goodsList: [],
      orderIdList: [],
      multipleSelection: [],
      dropDownListEdit: [],
      routeList: [
        {
          value: 1,
          label: this.$t('FBAContainerOrder.FBAContainerOrder1')
        },
        {
          value: 2,
          label: this.$t('FBAContainerOrder.FBAContainerOrder2')
        }
      ],
    }
  },
  created() {
    this.orderStatusOptions = [
      { value: "1", label: this.$t('filter.filter1'), jpLabel: t.filter.filter1 },
      { value: "2", label: this.$t('filter.filter2'), jpLabel: t.filter.filter2 },
      { value: "0", label: this.$t('filter.filter3'), jpLabel: t.filter.filter3 },
      { value: "4", label: this.$t('filter.filter4'), jpLabel: t.filter.filter4 },
      { value: "8", label: this.$t('filter.filter5'), jpLabel: t.filter.filter5 },
      { value: "12", label: this.$t('filter.filter6'), jpLabel: t.filter.filter6 },
      { value: '16', label: this.$t('filter.filter7'), jpLabel: t.filter.filter7 },
      { value: '20', label: this.$t('filter.filter8'), jpLabel: t.filter.filter8 },
      { value: '24', label: this.$t('filter.filter9'), jpLabel: t.filter.filter9 },
      { value: '26', label: this.$t('filter.filter10'), jpLabel: t.filter.filter10 },
      { value: '28', label: this.$t('filter.filter11'), jpLabel: t.filter.filter11 },
      { value: '32', label: this.$t('filter.filter12'), jpLabel: t.filter.filter12 },
      { value: '36', label: this.$t('filter.filter13'), jpLabel: t.filter.filter13 },
      { value: '40', label: this.$t('filter.filter14'), jpLabel: t.filter.filter14 },
      { value: '44', label: this.$t('filter.filter15'), jpLabel: t.filter.filter15 },
      { value: '48', label: this.$t('filter.filter16'), jpLabel: t.filter.filter16 },
      { value: '52', label: this.$t('filter.filter17'), jpLabel: t.filter.filter17 },
      { value: '56', label: this.$t('filter.filter18'), jpLabel: t.filter.filter18 },
      { value: '60', label: this.$t('filter.filter19'), jpLabel: t.filter.filter19 },
      { value: '64', label: this.$t('filter.filter20'), jpLabel: t.filter.filter20 },
      { value: '68', label: this.$t('filter.filter21'), jpLabel: t.filter.filter21 },
      { value: '72', label: this.$t('filter.filter22'), jpLabel: t.filter.filter22 },
      { value: '76', label: this.$t('filter.filter23'), jpLabel: t.filter.filter23 },
      { value: '80', label: this.$t('filter.filter24'), jpLabel: t.filter.filter24 },
      { value: '82', label: this.$t('filter.filter25'), jpLabel: t.filter.filter25 },
      { value: '83', label: this.$t('filter.filter26'), jpLabel: t.filter.filter26 },
      { value: '84', label: this.$t('filter.filter27'), jpLabel: t.filter.filter27 },
      { value: '88', label: this.$t('filter.filter28'), jpLabel: t.filter.filter28 },
      { value: '89', label: this.$t('filter.filter29'), jpLabel: t.filter.filter29 }
    ]
    this.getSendAddress()
  },
  methods: {
    openPacking(orderIdList) {
      this.dialogVisible = true
      // 不覆盖整个form，避免字段丢失导致选不中
      this.form.ids = ''
      this.form.comments = ''
      this.form.logisticsCompanyId = ''
      this.form.route = ''
      this.form.listOrderJson = ''
      this.form.logisticeCompany = ''

      this.goodsList = []
      this.multipleSelection = []
      this.orderIdList = orderIdList
      this.$refs.goodsTableRef?.clearSelection()
      this.getGoodsList()
    },
    async getGoodsList() {
      const { data: res } = await this.$http.post(
          "aws/amazonInventory/getOrderList",
          { orderIdList: this.orderIdList }
      )
      let goodsList = res.data;
      goodsList.forEach((item) => {
        item.containerGoodsCount = item.canApplyCount;
      });
      this.goodsList = goodsList
    },
    async getSendAddress() {
      const { data: res } = await this.$http.post("container/sendReceivingAddress")
      this.sendAddressList = res.data
    },
    handleSelect(selection) {
      this.multipleSelection = selection;
    },
    handleSelectAll(selection) {
      this.multipleSelection = selection;
    },
    // 选择线路
    lineChange(e) {
      this.form.logisticsCompanyId = ''
      this.getDropDownForLineList(e)
    },
    // 选择物流公司
    logisticsChange(companyId) {
      const selectedCompany = this.dropDownListEdit.find(company => company.id === companyId);
      if (selectedCompany) {
        this.form.logisticeCompany = selectedCompany.companyName;
      } else {
        this.form.logisticeCompany = '';
      }
    },
    async getDropDownForLineList(line) {
      if (line) {
        const { data: res } = await this.$http.get("cms/logisticsCompany/getDropDownForLineList/" + line + "?username=" + window.sessionStorage.getItem('username'))
        this.dropDownListEdit = res.data
      } else {
        this.dropDownListEdit = []
      }
    },
    // 提交表单
    handleSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          console.log('error submit!!');
          return false;
        }
        if (this.multipleSelection.length === 0) {
          return this.$message({
            showClose: true,
            message: '请选择商品',
            type: 'error'
          });
        }
        try {
          const params = {
            ...this.form,
            listOrderJson: JSON.stringify(this.multipleSelection)
          }
          const response = await this.$http.post('aws/amazonInventory/addContainerOrder', params)
          if (response.data.code !== 200) {
            return this.$message.error(response.data.message)
          }
          this.$message.success('提交成功')
          this.dialogVisible = false
          this.$refs[formName].resetFields();
          this.$emit('success')
        } catch (error) {
          console.error('提交失败', error)
          this.$message.error('提交失败')
        }
      })
    },
    // 取消表单
    cancelForm(formName) {
      this.dialogVisible = false
      this.$refs[formName].resetFields();
    },
  },
}
</script>

<style lang="less" scoped>
.el-dialog__body {
  padding: 20px;
}

.el-form-item {
  margin-bottom: 20px;
}

.align-start {
  display: flex;
  align-items: flex-start;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.font-style {
  display: flex;
  justify-content: center;
  width: 100%;

  .left {
    display: flex;
    justify-content: flex-end;
    width: 58px;
  }

  .right {
    max-width: calc(100% - 90px);
    min-width: 25px;
    text-align: left;
    flex: 1;
  }

  .text-over {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

::v-deep .el-form-item {
  margin-bottom: 20px;
}

::v-deep .el-dialog__body {
  padding: 0 20px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
